// extracted by mini-css-extract-plugin
module.exports = {"errorTitle":"Order_errorTitle__IyxMd"};